export const MediaType = {
    MOVIE : 'movie',
    TV : 'tv'
}
